import gql from "graphql-tag";

export const getOwnedProducts = gql`
  query getOwnedProducts(
    $name: QueryableString
    $price: QueryableFloat
    $createdAt: QueryableDateTime
    $limit: Int
    $cursor: String
  ) {
    accounts {
      fixedFee
      variableFee
    }
    stores {
      ownedProducts(
        name: $name
        price: $price
        createdAt: $createdAt
        limit: $limit
        cursor: $cursor
      ) {
        id
        name
        price
        createdAt
        isDonation

        activeOpportunities {
          id
          createdAt
          isActive
        }
      }
    }
  }
`;
